import { AccessLevel } from "@/api/williams/users";
import { faChevronDown, faChevronUp, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ScopeOfWork } from "@/api/williams/scopesOfWork";
import { usePermissions } from "../../users/hooks";
import { useState } from "react";
import { Warning } from "../../components/alerts";
import { QualificationStatus, Welder } from "@/api/williams/welders";
import { useWelderStatus } from "../../welders/hooks";

export type WelderRow = {
  welder: Welder;
  scope: ScopeOfWork;
  isRefreshing: boolean;
  onRemoveWelder: (welder: Welder) => void;
  onSelectionChanged: (welder: Welder, selected: boolean) => void;
};

export function SOWFormWelderRow({ welder, scope, onRemoveWelder, onSelectionChanged, ...props }: WelderRow) {
  const [expanded, setExpanded] = useState(false);
  const status = useWelderStatus(welder.welderId, scope);
  const permissions = usePermissions();

  return (
    <>
      <div className="d-flex justify-content-between mt-3">
        <div className="d-flex align-items-center">
          <button
            type="button"
            className="btn btn-link text-black p-0 lh-sm me-2"
            title="Remove Welder"
            onClick={() => onRemoveWelder(welder)}
            hidden={permissions.data?.accessLevel === AccessLevel.GeneralUser}
            disabled={scope.locked}
          >
            <FontAwesomeIcon icon={faXmark} border={true} />
          </button>

          <span>
            {welder.badgeNumber} {welder.name && <span className="d-none d-md-inline">({welder.name})</span>}
          </span>

          {welder.advisories && welder.advisories.length > 0 && (
            <FontAwesomeIcon
              role="button"
              icon={expanded ? faChevronUp : faChevronDown}
              size="sm"
              className="ms-1"
              title="View Advisories"
              onClick={() => setExpanded((prev) => !prev)}
              fixedWidth={true}
            />
          )}
        </div>

        <div className="d-flex">
          {status.isSuccess && (
            <small>
              {status.data.status === QualificationStatus.Ineligible ? (
                <div className="badge bg-secondary lh-sm">Ineligible</div>
              ) : status.data.status === QualificationStatus.NoQualifications ? (
                <div className="badge bg-secondary lh-sm">No Qualifications</div>
              ) : status.data.status === QualificationStatus.AllRevoked ? (
                <div className="badge bg-danger lh-sm">Revoked</div>
              ) : status.data.status === QualificationStatus.SomeRevoked ? (
                <div className="badge bg-warning lh-sm">Some Revoked</div>
              ) : status.data.status === QualificationStatus.AllExpired ? (
                <div className="badge bg-danger lh-sm">Expired</div>
              ) : status.data.status === QualificationStatus.SomeExpired ? (
                <div className="badge bg-warning lh-sm">Some Expired</div>
              ) : status.data.status === QualificationStatus.Current ? (
                <div className="badge bg-success lh-sm">Current</div>
              ) : (
                <></>
              )}
            </small>
          )}
          <input
            type="checkbox"
            className="form-check-input ms-3"
            onChange={(e) => onSelectionChanged(welder, e.currentTarget.checked)}
            hidden={permissions.data?.accessLevel === AccessLevel.GeneralUser}
          ></input>
        </div>
      </div>

      {expanded && (
        <div className="mt-2">
          {welder.advisories?.map((advisory, index) => (
            <Warning key={index}>{advisory}</Warning>
          ))}
        </div>
      )}
      <hr className="m-0 mt-2" />
    </>
  );
}
